import axios from "axios";

export default {
  namespaced: true,
  state: {
    shifts: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    shiftsMessage: ''
  },
  mutations: {
    DO_NOTHING(state) {
      state.isReceiving = false;
    },
    RECEIVED_SHIFTS(state, payload) {
      state.shifts = payload;
      state.isReceiving = false;
    },
    RECEIVING_SHIFTS(state) {
      state.isReceiving = true;
    },
    RECEIVED_SHIFT(state, payload) {
      state = Object.assign(state, {
        shifts: [...state.shifts, payload],
        isReceiving: false,
      })
    },
    RECEIVING_SHIFT(state) {
      state.isReceiving = true;
    },
    UPDATED_SHIFT(state, payload) {
      let index = state.shifts.findIndex(shift => shift._id === payload._id);
      state = Object.assign(state, {
        shifts: state.shifts.map((shift, i) => {
          if (i === index) {
            return Object.assign({}, shift, payload);
          }
          return shift;
        }),
        isUpdating: false,
        shiftsMessage: 'Shifts has been updating!',
      })
    },
    UPDATING_SHIFT(state) {
      state.isUpdating = true;
    },
    DELETED_SHIFT(state, payload) {
      let indexToDelete = state.shifts.findIndex(shift => shift._id === payload._id);
      let shifts = [...state.shifts];
      shifts.splice(indexToDelete, 1);
      state = Object.assign(state, {
        shifts: [...shifts],
        isDeleting: false,
        idToDelete: null,
        shiftsMessage: 'Shift has been Deleted!',
      });
    },
    DELETING_SHIFT(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    deleteShiftRequest({dispatch}, payload) {
      dispatch("deletingShift", payload);
      let token = localStorage.getItem('token')
      let url = 'https://api.tradexc.com:3000/delete/shift/' + payload._id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      axios({method: "delete", url: url,headers: headers})
      .then(function (response) {
        dispatch("deleteShift", response.data);
      })
      .catch(function (error) {
        console.log(error.data);
      });
    },

    async deleteShiftItemRequest({dispatch}, payload) {
      try{
        dispatch("deletingShift", payload);
        let token = localStorage.getItem("token");
        let url ="https://api.tradexc.com:3000/delete/shiftitem/" + payload._id;
        let headers = {"Content-Type": "application/json",Authorization: "Bearer " + token,};
  
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("deleteShift", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async deleteShiftScheduleRequest({dispatch}, payload) {
      try{
        dispatch("deletingShift", payload);
        let token = localStorage.getItem("token");
        let url ="https://api.tradexc.com:3000/delete/shiftschedule/" + payload._id;
        let headers = {"Content-Type": "application/json",Authorization: "Bearer " + token,};
  
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("deleteShift", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async deleteShiftTimeRequest({dispatch}, payload) {
      try{
        dispatch("deletingShift", payload);
        let token = localStorage.getItem("token");
        let url ="https://api.tradexc.com:3000/delete/shifttransaction/" + payload._id;
        let headers = {"Content-Type": "application/json",Authorization: "Bearer " + token,};
  
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("deleteShift", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async getShiftsRequest({dispatch}) {
      dispatch("receivingShifts");
      var token = localStorage.getItem('token');
      var url = 'https://api.tradexc.com:3000/get/shifts';
      var headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      return axios({method: "get",url: url,headers: headers})
      .then(res => {
        dispatch("receiveShifts", res.data);
      })
    },
    async getShiftScheduleRequest({dispatch}) {
      try{
        dispatch("doNothing");
        var token = localStorage.getItem('token');
        let url = 'https://api.tradexc.com:3000/get/shiftschedule';
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let response = await axios({method: "get", url: url, headers: headers});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async getShiftSchedulesRequest({dispatch}) {
      try{
        dispatch("doNothing");
        var token = localStorage.getItem('token');
        let url = 'https://api.tradexc.com:3000/get/shiftschedules';
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let response = await axios({method: "get", url: url, headers: headers});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async insertShiftRequest({dispatch}, payload) {
      dispatch("receivingShift");
      let  token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/insert/shift';
      let data = payload;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "post", url: url, headers: headers, data: data})
      .then((response)=> {
        dispatch("receiveShift", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.response.data.error;
      });	
    },
    async insertShiftItemRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/insert/shiftitem/' + payload.shiftid;
        let response = await axios({method: "post", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async insertShiftScheduleRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/insert/shiftschedule/' + payload.shiftid;
        let response = await axios({method: "post", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async insertShiftTimeRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        console.log(payload)
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/insert/shifttransaction/' + payload.scheduleid;
        let response = await axios({method: "post", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    updateShiftRequest({dispatch}, payload) {
      dispatch("updatingShift");
      let id = payload._id;
      delete payload['_id'];

      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/shift/' + id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      axios({method: "put", url: url,headers: headers,data: payload})
      .then(function (res) {
        dispatch("updateShift", res.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    async updateShiftItemRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/update/shiftitem/' + payload.shiftitemid;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateShiftTimeRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/update/shifttransaction/' + payload.shifttimeid;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateShiftScheduleConfirmRequest({dispatch}, payload) {
      dispatch("doNothing");
      var id = payload._id;
      delete payload['_id'];
      var token = localStorage.getItem('token');
      var url = 'https://api.tradexc.com:3000/update/shiftschedule/confirm/' + id;
      var header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      let response = await axios({method:"put", url:url, headers:header, data:payload})
      return response.data;
    },
    doNothing({commit}) {
      commit("DO_NOTHING")
    },
    receiveShifts({commit}, payload) {
      commit("RECEIVED_SHIFTS", payload)
    },
    receivingShifts({commit}) {
      commit("RECEIVING_SHIFTS")
    },
    receiveShift({commit}, payload) {
      commit("RECEIVED_SHIFT", payload)
    },
    receivingShift({commit}) {
      commit("RECEIVING_SHIFT")
    },
    updateShift({commit}, payload) {
      commit("UPDATED_SHIFT", payload)
    },
    updatingShift({commit}) {
      commit("UPDATING_SHIFT")
    },
    deleteShift({commit}, payload) {
      commit("DELETED_SHIFT", payload)
    },
    deletingShift({commit}, payload) {
      commit("DELETING_SHIFT", payload)
    }
  },
};
